import { IconButton, makeStyles } from "@material-ui/core";
import { ReactComponent as CheckMarkIcon } from "assets/checkmarkIcon.svg";
import React, { FunctionComponent } from "react";
import ClearIcon from "@material-ui/icons/Clear";
import { ICardElementWithChildren } from "backend/model/model";
import ElementIcon from "../icons/ElementIcon";
import { t } from "i18next";

const useStyle = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    width: "100%",
    height: "150px",
    justifyContent: "center",
    alignItems: "center",
    border: "1px solid rgba(0, 0, 0, 0.05)",
    background: "#fff",
    borderRadius: "4px",
    padding: "10px 10px",
    "& svg path": {
      fill: "#296Ba2",
    },
  },
  text: {
    color: "rgba(121, 125, 132, 1)",
    fontSize: "small",
    fontWeight: 500,
    lineHeight: "2.307em",
    letterSpacing: "0.04375px",
    wordWrap: "break-word",
    flexGrow: 1,
    textAlign: "center",
  },
  img: {
    width: "80%",
    textAlign: "center",
  },
  header: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    position: "relative",
  },
  closeIcon: {
    position: "absolute",
    insetInlineEnd: "10px",
  },
  headerText: {},
}));

interface ScopeCardProps {
  selectedReport?: ICardElementWithChildren | null;
  selectedReportName?: string;
  title?: string;
  subtitle?: string;
  img?: JSX.Element;
  onRemove?: () => void;
  showClearBtn?: boolean;
}

const ScopeCard: FunctionComponent<ScopeCardProps> = (props) => {
  const styles = useStyle();
  const { selectedReport } = props;
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={`${styles.text} ${styles.headerText}`}>{props.title}</div>
        {props.onRemove && props.showClearBtn ? (
          <div className={styles.closeIcon}>
            <IconButton
              onClick={() => {
                if (props.onRemove) {
                  props.onRemove();
                }
              }}
            >
              <ClearIcon />
            </IconButton>
          </div>
        ) : null}
      </div>
      <div className={styles.img}>
        {selectedReport ? (
          <ElementIcon size={30} item={selectedReport} />
        ) : (
          <CheckMarkIcon />
        )}
      </div>
      <div className={styles.text}>
        {selectedReport
          ? `${props.selectedReportName}`
          : t("reports.Select scope from the list")}
      </div>
    </div>
  );
};

export default ScopeCard;
